import React, { createContext, useContext, useRef } from 'react';
import { Toast } from 'primereact/toast';

const ToastContext = createContext();

export const ToastProvider = ({ children }) => {
    const toast = useRef(null);

    const showToast = (severity, summary, detail, life = 3000) => {
        toast.current?.show({ severity, summary, detail, life });
    };

    const showToastObj = (toastObj) => {
        toast.current?.show(toastObj);
    };

    return (
        <ToastContext.Provider value={{ showToast, showToastObj }}>
            <Toast ref={toast} />
            {children}
        </ToastContext.Provider>
    );
};

export const useToast = () => {
    const context = useContext(ToastContext);
    if (!context) {
        throw new Error('useToast must be used within a ToastProvider');
    }
    return context;
};
